import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@app/app.service';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { RewardBoxComponent } from '@app/shared/components/reward-box/reward-box.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { GlobalDataRepository } from '@app/shared/state/global-data/global-data.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-tournament-start',
  templateUrl: './tournament-start.component.html',
  styleUrls: ['./tournament-start.component.scss'],
  standalone: true,
  imports: [ButtonComponent, AnimatedTimerComponent, RewardBoxComponent, SharedModule],
})
export class TournamentStartComponent implements OnInit {
  tournamentStartModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private eventsRepo = inject(EventsRepository);
  private translateService = inject(TranslateService);
  private assetsService = inject(AssetsService);
  private gamesRepo = inject(GamesRepository);
  private globalDataRepo = inject(GlobalDataRepository);
  private appService = inject(AppService);

  private lang: string;

  event: LimitedTimeEvent;

  gameName: string;
  gameIcon: unknown;
  gameId: string;
  buttonText: string;

  ngOnInit() {
    this.event = this.eventsRepo.getEventById(this.tournamentStartModalData.properties.eventId);
    this.lang = this.translateService.currentLang;
    this.gameId = this.event?.liveOpsStatus?.challengeStatus?.gameId;

    this.buttonText = this.getButtonText();

    if (this.gameId) {
      this.gameName = this.gamesRepo.getGameById(this.gameId)?.gameTitle;
      this.gameIcon = {
        'background-image': `url('${this.assetsService.getGameIconUrl(this.gameId)}')`,
      };
    }
  }

  handleStartButtonClick(): void {
    if (this.gameId && this.globalDataRepo.getCurrentGame() !== this.gameId) {
      this.closeModal(true);
      this.appService.showGame(this.gameId);
    } else {
      this.closeModal();
    }
  }

  getButtonText(): string {
    return this.tournamentStartModalData.properties.buttonText[this.lang]
      ? this.tournamentStartModalData.properties.buttonText[this.lang]
      : 'home.live-ops.tournaments.button';
  }

  closeModal(goGame?: boolean): void {
    this.eventManager.closeModal(
      new Modal(this.tournamentStartModalData.id, ModalType.Persisted, this.tournamentStartModalData, '', goGame)
    );
  }
}
